import type { StartPhaseManager } from '@/app/phases/StartPhaseManager'
import {
  blurState,
  inputsState,
  tutorialState
} from '@/stores'
import {
  tutorialManager,
  TutorialSectionType,
  TutorialMessageColors,
  game,
  modes,
  gameStats,
  requestManager,
  MobileDetector
} from '@powerplay/core-minigames'
import { gatesManager } from '../../GatesManager'
import { disciplinePhasesManager } from '../../phases/DisciplinePhasesManager'
import {
  SectionNames,
  TutorialEventType,
  TutorialObjectiveIds,
  DisciplinePhases
} from '../../types'
import { tutorialObjectives } from './TutorialObjectives'
import { tutorialUIChange } from './TutorialUIChange'
import { loadingCircleState } from '@powerplay/core-minigames-ui'

/**
 *  Tutorial tasky ktore maju aj logiku v sebe na ovladanie tej ktorej udalosti
 */
export class TutorialFlow {

  /** aktualny typ eventu */
  private activeEventType = TutorialEventType.awaitingEvent

  /** ci sa triggerol event gateMiss alebo finish  */
  private gateEventTriggered = false

  /** ci sa triggerol event plotu */
  public fenceEventsTriggered = false

  /** Fix of flow at tutorial end  */
  private final = false

  /**
   * Inicializacia
   */
  public init(): void {

    const objectives = [
      {
        id: TutorialObjectiveIds.start as string,
        passed: false,
        failed: false,
        name: 'tutorialTask1-1'
      },
      {
        id: TutorialObjectiveIds.gates as string,
        passed: false,
        failed: false,
        name: 'tutorialTask1-2'
      }
    ]
    tutorialObjectives.setObjectives(objectives)
    const tutorialSections = [
      {
        name: SectionNames.mobileSidePick,
        id: 0,
        type: TutorialSectionType.storyInput,
        sectionLogicIntro: () => {

          inputsState().isVisible = false

        },
        sectionLogicFinish: () => {

          // document.getElementsByTagName('canvas')[0].classList.remove('blur-class')
          blurState().isActive = false
          tutorialState().showObjectives = true
          inputsState().isVisible = true

        }
      },
      {
        name: SectionNames.startSection,
        id: 1,
        type: TutorialSectionType.storyInput
      },
      {
        name: SectionNames.startSectionSecond,
        id: 2,
        type: TutorialSectionType.storyInput,
        sectionLogicIntro: () => {

          const startPhaseManager = disciplinePhasesManager
            .getDisciplinePhaseManager(DisciplinePhases.start) as StartPhaseManager
          startPhaseManager.showBarTutorial()

        },
        sectionLogicFinish: () => {

          tutorialState().showButtonStart = false
          const startPhaseManager = disciplinePhasesManager
            .getDisciplinePhaseManager(DisciplinePhases.start) as StartPhaseManager
          startPhaseManager.launchSystem()

        }
      },
      {
        name: SectionNames.startSectionThird,
        id: 3,
        type: TutorialSectionType.gameButton
      },
      {
        name: SectionNames.startSectionFourth,
        id: 4,
        type: TutorialSectionType.storyInput,
        sectionLogicFinish: () => {

          tutorialState().showButtonsMovement = false

        }
      },
      {
        name: SectionNames.startSectionFifth,
        id: 5,
        type: TutorialSectionType.gameEvent,
        sectionLogicIntro: () => {

          /*
           * spusti sa detekcia neprejdenia branky a naraz do barier
           * podla toho text
           * plus detekujem prechod poslednou brankou, kedy posunieme task
           */

        },
        sectionLogicFinish: () => {

          if (gameStats.wasExitedGame()) {

            requestManager.redirect()
            return

          }

          game.prematureFinishGame(disciplinePhasesManager.disciplinePrematureEnd)

          loadingCircleState().isActive = true

        }
      }
    ]

    tutorialManager.setTutorialSections(tutorialSections)

    const firstTutorialStrings = ['chooseFirstDisciplineReturnFromMinigame', 'chooseFirstDisciplineContinue']
    if (MobileDetector.isMobile() && firstTutorialStrings.includes(requestManager.TUTORIAL_ID ?? '')) return

    tutorialManager.setActualSectionId(1)

  }

  /**
   * Public metoda do game loopu
   */
  public update(): void {

    // this.checkInput()
    tutorialUIChange.update()
    tutorialObjectives.update()

  }

  /**
   * Skontrolovanie inputov
   */
  public checkInput(): void {

    if (TutorialSectionType.gameEvent === tutorialManager.getActualSectionType()) {

      this.eventActionPressed()

    }

  }

  public eventActionTrigger(eventType: TutorialEventType): void {

    if (!modes.isTutorial()) return
    this.activeEventType = eventType

    if (eventType === TutorialEventType.fenceEvent && !this.fenceEventsTriggered) {

      this.fenceEventsTriggered = true
      game.pauseGame()
      tutorialUIChange.setMessage(true, 'tutorialText1-5')
      tutorialUIChange.setAnne(true)

    }
    if (eventType === TutorialEventType.gateMissEvent && !this.gateEventTriggered) {

      this.gateEventTriggered = true
      game.pauseGame()
      tutorialUIChange.setMessage(true, 'tutorialText1-4')
      tutorialUIChange.setAnne(true)

    }
    if (eventType === TutorialEventType.finishEvent) {

      this.gateEventTriggered = true
      game.pauseGame()

      if (gatesManager.failedCounter >= 10) {

        tutorialUIChange.setMessage(true, 'tutorialText1-6', TutorialMessageColors.red)
        tutorialUIChange.setAnne(true)

      } else {

        if (this.final) return
        this.final = true
        tutorialUIChange.setMessage(true, 'tutorialText1-7', TutorialMessageColors.green)
        tutorialUIChange.setAnne(true, false)

      }

    }

  }

  public eventActionPressed(): void {

    if (game.paused) game.resumeGame()
    tutorialUIChange.setMessage(false, '')
    tutorialUIChange.setAnne(false)

    if (this.activeEventType === TutorialEventType.finishEvent) {

      tutorialManager.nextSection()

    }

    this.activeEventType = TutorialEventType.awaitingEvent

  }

  public finishAction(): void {

    this.eventActionTrigger(TutorialEventType.finishEvent)
    // disciplinePhasesManager.resetAttempt()

  }

}

export const tutorialFlow = new TutorialFlow()
